import React from "react";
import { Typography } from "@material-tailwind/react";
import ContentImage from "../../assets/images/Contents/bg-4.png";
// import Wellness-flower from "../../assets/images/Contents/welcome-content-1.png";
import carepointImage3 from "../../assets/images/wellnesscarepoint/banner-vector-1.png";
import carepointImage4 from "../../assets/images/wellnesscarepoint/banner-vector-2.png";
import WellnessLogo from "../../assets/images/Logos/wellness-flw-2.png";

import FloatingImageright from "../../assets/images/Decorations/bg-leaf2.png";
import FloatingImagerightmobile from "../../assets/images/Decorations/inner-leaf-right.png";


import { Link } from "react-router";

function WelcomeContent() {
  return (
    <>
      {/* <div className="my-8 bg-blue-300 sm:bg-red-300 md:bg-yellow-300 lg:bg-green-300 xl:bg-purple-300 2xl:bg-orange-300"> */}

      <div className="flex justify-end ">
        <img
          src={FloatingImageright}
          alt="image 2"
          className="absolute -mr-7 z-10 object-cover  md:block hidden xl:h-auto xl:w-auto animate-float"
        />
      </div>
      <div className="flex justify-end">
        <img
          src={FloatingImagerightmobile}
          alt="image 2"
          className="absolute -mr-7 z-10 object-cover  block md:hidden h-56 w-24 animate-float"
        />
      </div>

      <div className="my-8">
        <div className="w-full h-full flex flex-col lg:flex-row  justify-center">
          <div className="flex w-full lg:w-5/12 justify-center  rtolblock">

            <div className="flex justify-start">
              <img
                src={carepointImage3}
                alt="image 2"
                className="absolute z-10 object-cover h-24 w-28 xl:h-40 xl:w-44 animate-shake-slow"
              />
            </div>

            <div className="bg-center w-full h-full  lg:block px-10 lg:px-0 xl:px-0">
              <img alt="welcome-image" src={ContentImage} />
            </div>
          </div>
          <div className="w-full lg:w-5/12 shadow-md  content-center ltorblock ">

            <div className="px-5 ">
              <div className="w-full flex flex-col items-center">
                <img
                  src={WellnessLogo}
                  alt="image 2"
                  className="h-14 w-26 full object-cover"
                // className="h-34 w-64 full object-cover"
                />

                <Typography className="tracking-widest text-[.6rem] xl:text-sm mt-4 text-customMaroon-35 uppercase title_DMSerifText-Regular">
                  Serene Elegance in Sri Lankan ayurveda
                </Typography>
              </div>

              <Typography
                variant="h2"
                color="blue-gray"
                className="text-center px-5 lg:pt-3  title_DMSerifText-Regular uppercase lg:text-[2rem] text-[1.2rem]"
              >
                Welcome to Ceylon Hospital Wellness
              </Typography>
              <div className="text-center px-1  md:px-16 xl:px-0 pb-5">
                <div className="px-1 py-3">
                  <p className="description_AlegreyaSans-Light lg:leading-5 leading-tight text-xm">
                    Discover the timeless wisdom of Ayurveda and Hela Wedakama,
                    the treasured Sri Lankan art of indigenous healing, at
                    Ceylon Hospital Wellness.
                  </p>

                  <p className="py-4 description_AlegreyaSans-Light leading-5 text-xm">
                    Guided by the expertise of renowned Ayurvedic physicians,
                    our bespoke treatments are crafted to restore balance,
                    rejuvenate your spirit, and awaken the natural harmony of
                    your mind, body, and soul. Whether you're seeking to heal,
                    recharge, or rediscover yourself, our personalized care and
                    proven traditions provide the perfect sanctuary for your
                    journey.
                  </p>
                  <p className="description_AlegreyaSans-Light leading-5 text-xm">
                    Embrace a life inspired by well-being, guided by ancient
                    practices designed to transform and elevate your way of
                    living.
                  </p>
                </div>

                <Link to={"/AboutUs"}>
                  <div className="flex normal_link slick_title mt-6">
                    <h6 className="font-bold  text_PlayfairDisplay-VariableFont_wght uppercase text-sm">
                      Read more About us
                    </h6>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WelcomeContent;
